import {
    DriverAttachment,
    DriverParameter,
} from "../../../../types/types";

export const createInitialDriverParameter = (
    driverId: number,
    customerId: number,
): DriverParameter => ({
    id: null,
    driverId,
    customerId,
    workScheduleId: null,
    workScheduleName: null,
    daysOff: [],
    makesExternalTrips: false,
    usesDriverLogin: false,
    receivesAlerts: false,
    observation: null,
    activated: true,
    files: [],
    removedFiles: [],
});

export const normalizeDriverParameterResponse = (
    response: DriverParameter,
    driverId: number,
    customerId: number,
): DriverParameter => ({
    ...createInitialDriverParameter(driverId, customerId),
    ...response,
    driverId,
    customerId,
    daysOff: Array.isArray(response.daysOff) ? response.daysOff : [],
    files: Array.isArray(response.files) ? response.files : [],
    removedFiles: [],
});

export const buildDriverParameterPayload = ({
    driverParameter,
    driverId,
    customerId,
    newFiles,
    removedFiles,
}: {
    driverParameter: DriverParameter;
    driverId: number;
    customerId: number;
    newFiles: DriverAttachment[];
    removedFiles: number[];
}): DriverParameter => ({
    ...driverParameter,
    driverId,
    customerId,
    observation: driverParameter.observation?.trim() || null,
    files: newFiles.map((file) => ({
        file: file.file,
        description: file.description?.trim() || null,
        name: file.name,
        type: file.type,
    })),
    removedFiles,
});

export const WEEK_DAYS: Array<{ value: number; label: string }> = [
    { value: 0, label: "Domingo" },
    { value: 1, label: "Segunda-feira" },
    { value: 2, label: "Terça-feira" },
    { value: 3, label: "Quarta-feira" },
    { value: 4, label: "Quinta-feira" },
    { value: 5, label: "Sexta-feira" },
    { value: 6, label: "Sábado" },
];
